import React, { useEffect } from 'react'
import { ROUTE } from '../../route/Route'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import SeoAdd from '../Seo/SeoAdd'
import { useTranslation } from "react-i18next";

const DirectorMessage = () => {
    const { t } = useTranslation();
    useEffect(() => {
        window?.scrollTo(0, 0);
        return () => { }
    }, [])
    return (
        <>
            <SeoAdd slug={ROUTE.DIRECTORMESSAGE} />
            <BreadCrumb page={t("director_message")} data={{ slug: "", path: "#" }} />
            <section className='about-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-3'></div>
                        <div className='col-md-9 dir_heading'>
                            <div className="headingmains text-md-left text-center dir-head">
                                <h1>{t("director_message")}</h1>
                            </div>
                        </div>
                    </div>
                    <div className='row align-items-center'>
                        <div className='col-md-12 row dir_about'>
                            <div className='col-md-3 dir_img'>
                                <img src={t("images.dir")} alt='' />
                            </div>
                            <div className='col-md-9 dir_info'>
                            <div className="dir-name-info">
                                <h4>{t("director_name")}</h4>
                                <span>{t("director_position")}</span>
                                <h6>{t("director_ownership")}</h6>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-3'>
                            </div>
                            <div className='col-md-9 dir_msg'>
                                <p className='mb-3' dangerouslySetInnerHTML={{ __html: t("director_bold_text") }}></p>
                                <div className='dir-footer'>
                                    <h6 className='mb-3'>{t("faithfully")}</h6>
                                    <h4 className='mb-2'>{t("director_name")}</h4>
                                    <div className='mb-2'>{t("director_position")}</div>
                                    <h6>{t("director_ownership")}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DirectorMessage

